import React from "react";
import { Button, Spinner, Image, Col, Form } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import { fetchPrograms } from "./services/DataService";
import "./style/program.scss";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import yeslogo from "./images/icon-yes.svg";
import nologo from "./images/icon-no.svg";
import paginationFactory from "react-bootstrap-table2-paginator";

class Program extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      filtered: [],
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.timeout = null;
    this.programs = [];
  }

  componentDidMount() {
    this.setState({ loading: true });
    fetchPrograms("").then((programs) => {
      this.programs = programs;
      this.setState({ loading: false, filtered: programs });
    });
  }

  onSearchChange(event) {
    let search = event.target.value;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      let filtered = this.programs;
      if (search !== "") {
        let terms = search.toLowerCase().split(" ");
        terms.map((term) => {
          return (filtered = filtered.filter((item) =>
            `${item.name.toLowerCase()}`.includes(term)
          ));
        });
      }
      this.setState({
        filtered: filtered,
      });
    }, 800);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" className="kugs-spinner">
          <span className="sr-only">Loading...</span>
        </Spinner>
      );
    }
    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        this.setState({ redirect: `/programs/${row.id}` });
      },
      onMouseEnter: (e, row, rowIndex) => {
        e.target.parentNode.className = "row-enter";
      },
      onMouseLeave: (e, row, rowIndex) => {
        e.target.parentNode.className = "row-leave";
      },
    };
    let sortCarets = (order, column) => {
      if (!order)
        return (
          <span className="sort-glyph-group">
            <span className="sort-glyph-both glyphicon glyphicon-triangle-top"></span>
            <span className="sort-glyph-both glyphicon glyphicon-triangle-bottom"></span>
          </span>
        );
      else if (order === "asc")
        return (
          <span className="sort-glyph glyphicon glyphicon-triangle-top"></span>
        );
      else if (order === "desc")
        return (
          <span className="sort-glyph glyphicon glyphicon-triangle-bottom"></span>
        );
      return null;
    };

    const dayOfWeekColumns = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    const daysOfWeekColumnDefinitions = dayOfWeekColumns.map((day) => ({
      dataField: day,
      text: day.charAt(0).toUpperCase() + day.slice(1, 3),
      formatter: (cellContent, row) => {
        if (row[day])
          return <Image src={yeslogo} width="25" height="25" alt="yes " />;
        return <Image src={nologo} width="25" height="25" alt="no " />;
      },
    }));

    const pageButtonRenderer = ({
      page,
      active,
      onSizePerPageChange,
      onPageChange,
    }) => {
      const handleClick = (e) => {
        e.preventDefault();
        onPageChange(page);
      };
      const activeStyle = {};
      if (active) {
        activeStyle.backgroundColor = "black";
        activeStyle.color = "red";
      } else {
        activeStyle.backgroundColor = "black";
        activeStyle.color = "white";
      }
      if (typeof page === "string") {
        activeStyle.backgroundColor = "black";
        activeStyle.color = "white";
      }
      return (
        <a
          href="/#"
          className="page-link"
          onClick={handleClick}
          style={activeStyle}
          key={page}
        >
          {page}
        </a>
      );
    };
    const options = {
      pageButtonRenderer,
    };

    return (
      <div>
        <Col sm="6" className="searchbar">
          <Button
            variant="primary"
            href="programs/add"
            className="glyphicon glyphicon-plus btn-add "
          >
            <div className="hidden">Add</div>
          </Button>
          <div className="search-icon glyphicon glyphicon-search"></div>
          <Form.Control
            type="text"
            className="search-box"
            onChange={this.onSearchChange}
          />
        </Col>

        <BootstrapTable
          keyField="id"
          responsive="sm"
          sizePerPage="100"
          size="sm"
          data={this.state.filtered}
          rowEvents={rowEvents}
          rowStyle={{ fontSize: 20, maxWidth: "10%" }}
          pagination={paginationFactory(options)}
          columns={[
            {
              dataField: "name",
              text: "Name",
              sort: true,
              sortCaret: sortCarets,
              headerStyle: (column, colIndex) => {
                return { width: "20%" };
              },
            },
            ...daysOfWeekColumnDefinitions,
            {
              dataField: "start_time",
              text: "Start",
              sort: true,
              headerStyle: (column, colIndex) => {
                return { width: "9%" };
              },
              sortCaret: sortCarets,
              formatter: (cell) => {
                return cell.slice(0, 5);
              },
            },
            {
              dataField: "end_time",
              text: "End",
              sort: true,
              sortCaret: sortCarets,
              formatter: (cell) => {
                return cell.slice(0, 5);
              },
            },
          ]}
        />
      </div>
    );
  }
}

export default Program;
